import { useContext, useEffect } from "react";
import { EntityContext } from "../../../../contexts/EntityContext";
import {
  getLocalStorageData,
  clearLocalStorageData,
} from "../../../../shared/utils/localStorage";
import { Box, Grid } from "@mui/material";
import CardTiles from "../../../../shared/components/cardTiles";
import SvgIcons from "../../../../shared/components/svgIcons";
import useQuery from "../../../../shared/components/hooks/useQuery";
import { formatAmountINR } from "../../../../shared/utils/amountFormat";

const Dashboard = () => {
  const { setEntityName } = useContext(EntityContext);
  const { data } = useQuery("/admin/students/dashboard-stats", null);

  useEffect(() => {
    getLocalStorageData("token");
    setEntityName({
      entityName: "Admin Dashboard",
      entityTitle: "Fee Collection",
    });
  }, [setEntityName]);

  useEffect(() => {
    const token = getLocalStorageData("token");
    if (!token) {
      clearLocalStorageData();
      window.location.href = "/login";
    }
  }, []);

  const stats = (data as any)?.data || {};
  const totalStudents = stats.totalStudents || 0;
  const collectedFees = stats.collectedFees || 0;
  // const pendingFees = stats.pendingFees || 0;

  return (
    <Box className="dashBoardMain">
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={6}>
          <CardTiles
            number={totalStudents}
            title="Total Students"
            Icon={<SvgIcons.TotalUsersIcon />}
          />
        </Grid>
        <Grid item xs={6}>
          <CardTiles
            number={formatAmountINR(collectedFees)}
            title="Collected Fees"
            Icon={<SvgIcons.RevenueIcon />}
          />
        </Grid>
        {/* <Grid item xs={4}>
          <CardTiles
            number={formatAmountINR(pendingFees)}
            title="Pending Fees"
            Icon={<SvgIcons.ServiceProvidersIcon />}
          />
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default Dashboard;
